import React from 'react';
import { useLocation } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import { Constrain, Stack, Breakpoint, Divider } from '@moda/om';
import { AccountHelpLinks } from '../../components/AccountHelpLinks';
import { AccountNav } from '../../components/AccountNav';
import { RedirectWithStatusCode } from '../../components/RedirectWithStatusCode';
import { useUser } from '../../hooks/useUser';
import { hrefFor } from '../../routers';
import { AccountPageContent, Props } from './AccountPageContent';

import './AccountPage.scss';

export const AccountPage: React.FC<Props> = props => {
  const location = useLocation();
  const {
    user: { isLoggedIn }
  } = useUser();

  if (!isLoggedIn) {
    return (
      <RedirectWithStatusCode
        statusCode={StatusCodes.MOVED_TEMPORARILY}
        to={`${hrefFor.RegisterPage()}?redirectTo=${location.pathname}`}
      />
    );
  }

  return (
    <Constrain className="AccountPage">
      <Breakpoint lt="md">
        <Stack className="AccountPage__layout--mobile" space={4}>
          <div className="AccountPage__content-wrapper AccountPage__content-wrapper--mobile">
            <AccountPageContent {...props} />
          </div>
        </Stack>
      </Breakpoint>

      <Breakpoint gt="md">
        <div className="AccountPage__layout--desktop">
          <Stack className="AccountPage__nav" space={3}>
            <AccountNav />

            <Divider />

            <AccountHelpLinks />
          </Stack>

          <div className="AccountPage__content-wrapper AccountPage__content-wrapper--desktop">
            <AccountPageContent {...props} />
          </div>
        </div>
      </Breakpoint>
    </Constrain>
  );
};
